
	export default {
		computed: {
			employeePolicy () {
				return this.$store.getters.employeePolicy
			},
			internationalBancard: {
				get () {
					return this.$store.state.internationalBancard
				},
				set (value) {
					this.$store.commit('setState', {
						key: 'internationalBancard',
						value,
						save: true
					})
				}
			}
		}
	}
